export default {"src":"/kaimono/_next/static/media/wamazing_snow_h.66bb553c.svg","height":117,"width":417};